/* eslint-disable prettier/prettier */
/* eslint-disable no-useless-escape */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-constant-condition */
import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { v4 as uuidv4 } from 'uuid'
import { Modal, Row, Col, Form, Button, Spinner } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCirclePlus,
  faEdit,
  faSave,
  faTimes,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons'
import JSZip from 'jszip';
import DefaultCarouselPreview from './DefaultCarouselPreview'
import StickyAdPreview from './StickyAdPreview'
import PictureInPicturePreview from './PictureInPicturePreview'
import NotePreview from './NotePreview'
import SocialPostPreview from './SocialPostPreview'
import SlidingCoverPreview from './SlidingCoverPreview'
import MarqueePreview from './MarqueePreview'
import DoubleRotatePreview from './DoubleRotatePreview'
import ShowVideoPreview from './ShowVideoPreview'
import CoverflowPreview from './CoverflowPreview'
import TwentytwentyPreview from './TwentytwentyPreview'
import CarouselStickyPreview from './CarouselStickyPreview'
import SlidingCoverMultiPreview from './SlidingCoverMultiPreview'
import CarouselPreview from './CarouselPreview'
import DoubleRotateVerticalPreview from './DoubleRotateVerticalPreview'
// import RotateFerrisWheelPreview from './RotateFerrisWheelPreview'
import RotateCubePreview from './RotateCubePreview'
import NoteCarouselPreview from './NoteCarouselPreview'
import PizzaPreview from './PizzaPreview'
import ImageAndVideoPreview from './ImageAndVideoPreview'
import IntroAnimation from './IntroAnimation'
import FullScreenPreview from './FullScreenPreview'
import SlidingCoverMultiStickyPreview from './SlidingCoverMultiStickyPreview'
import CoverflowCirclePreview from './CoverflowCirclePreview'
import RotateCubeStickyPreview from './RotateCubeStickyPreview'
import RotateCirclePreview from './RotateCirclePreview'
import DragChangePreview from './DragChangePreview'
import MoveinPreview from './MoveinPreview'
import MoveinVideoPreview from './MoveinVideoPreview'
import BookWithVideoPreview from './BookWithVideoPreview'
import PageFlipPreview from './PageFlipPreview'
import CarouselFilmPreview from './CarouselFilmPreview'
import IntroWith320HStaticPreview from './IntroWith320HStaticPreview'
import IntroWith320HDynamicPreview from './IntroWith320HDynamicPreview'
import IntroWith320HCirclePreview from './IntroWith320HCirclePreview'
import IntroWith320HCircleVideoPreview from './IntroWith320HCircleVideoPreview'
import DesktopBannerPreview from './DesktopBannerPreview'
import DesktopVideoBannerPreview from './DesktopVideoBannerPreview'
import DesktopContentPreview from './DesktopContentPreview'
import DesktopContentCarousel from './DesktopContentCarousel'
import DesktopStickyCarousel from './DesktopStickyCarousel'
import PizzaStickyPreview from './PizzaStickyPreview'
import PageFlipWithBannerPreview from './PageFlipWithBannerPreview'
import MagicCardPreview from './MagicCardPreview'
import apiServices from '../services/apiServices'
import transformer from '../services/videoTransformer'

async function cacheToZip(cacheArr) {
  const zip = new JSZip();

  for (let i = 0; i < cacheArr.length; i += 1) {
    const img = cacheArr[i];

    // ▶ 將 ImageData 畫進 OffscreenCanvas
    const off = new OffscreenCanvas(img.width, img.height);
    off.getContext('2d').putImageData(img, 0, 0);

    // ▶ 轉成壓縮率高的 WebP
    // eslint-disable-next-line no-await-in-loop
    const blob = await off.convertToBlob({ type: 'image/webp', quality: 0.8 });

    zip.file(`frame-${String(i).padStart(3, '0')}.webp`, blob);
  }

  // ▶ 返回整個 ZIP 的 Blob（不占 JS Heap）
  return zip.generateAsync({ type: 'blob' });
}

const jsModuleTypes = {
  預設輪播: 'DefaultCarouselPreview',
  切入式廣告: 'MoveinPreview',
  '切入式廣告(影片)': 'MoveinVideoPreview',
  // '開場+320H翻玩影音廣告': 'IntroWith320HCircleVideoPreview',
  // '開場+320H翻玩廣告': 'IntroWith320HCirclePreview',
  // '開場+320H靜態廣告': 'IntroWith320HStaticPreview',
  // '開場+320H動態廣告': 'IntroWith320HDynamicPreview',
  手翻型錄廣告: 'PageFlipPreview',
  翻書影音廣告: 'BookWithVideoPreview',
  全屏畫布: 'FullScreenPreview',
  滑動蓋板: 'SlidingCoverPreview',
  '滑動蓋板（多圖）': 'SlidingCoverMultiPreview',
  便利貼: 'NotePreview',
  '便利貼（輪播）': 'NoteCarouselPreview',
  拖曳互動: 'DragChangePreview',
  飛梭膠卷影音廣告: 'CarouselFilmPreview',
  '視覺雙響-文中翻頁蓋板+快閃動畫': 'SlidingCoverMultiStickyPreview',
  手翻型錄Banner廣告: 'PageFlipWithBannerPreview',
  魔法卡片: 'MagicCardPreview',
  置底迴廊: 'CoverflowCirclePreview',
  // Add desktop types if they have corresponding JS modules
  告示牌大橫幅廣告: 'DesktopBannerPreview', // Assuming these exist
  告示牌影音橫幅廣告: 'DesktopVideoBannerPreview', // Assuming these exist
  '置底-雙面旋轉': 'DoubleRotateVerticalPreview',
  '雙面旋轉': 'DoubleRotatePreview',
  包框影音: 'ImageAndVideoPreview', 
  展示影音: 'ShowVideoPreview',
  行動置底展開: 'StickyAdPreview'
}

function NamedInput({ setting }) {
  const { file, size, type, accept, onChange = () => {} } = setting
  const inputId = useRef(`file-input-${uuidv4()}`)
  console.log(file)
  return (
    <>
      <Form.Label htmlFor={inputId.current} className="w-100 my-0">
        <Form.Control
          size={size}
          type="text"
          value={file?.file ? file.file.name || file.label : file?.name || ''}
          placeholder="請選擇檔案"
          readOnly
          style={{
            cursor: 'pointer',
          }}
          onClick={() => document.getElementById(inputId.current).click()}
        />
      </Form.Label>
      <Form.Control
        className="d-none"
        id={inputId.current}
        size={size}
        type={type}
        accept={accept}
        onChange={onChange}
      />
    </>
  )
}

function TrackerSetting({ setting }) {
  const { creative_id } = setting

  const [trackers, settrackers] = useState([])
  const getTrackers = async () => {
    const res = await apiServices.data({
      path: `tracker/list/${creative_id}`,
      method: 'get',
    })
    settrackers(res)
  }
  useEffect(() => {
    if (creative_id) getTrackers()
  }, [creative_id])
  console.log(trackers)

  const [editingId, setEditingId] = useState(null)
  const [form, setForm] = useState({ name: '', text: '' })

  const handleADD = async () => {
    await apiServices.data({
      path: `tracker/${creative_id}`,
      method: 'post',
      data: {
        name: '',
        text: '',
      },
    })
    getTrackers()
  }

  const handleEdit = (tracker) => {
    setEditingId(tracker.tracker_id)
    setForm({
      name: tracker.setting.name,
      text: tracker.setting.text,
    })
  }

  const handleCancel = () => {
    setEditingId(null)
    setForm({ name: '', text: '' })
  }

  const handleSave = async (tracker_id) => {
    // TODO: 將 form 送到後端
    await apiServices.data({
      path: `tracker/${tracker_id}`,
      method: 'put',
      data: { name: form.name, text: form.text },
    })
    getTrackers()
    handleCancel()
  }

  const handleDelete = async (tracker_id) => {
    if (!window.confirm('確定要刪除嗎？')) return
    // TODO: 呼叫後端刪除
    await apiServices.data({
      path: `tracker/${tracker_id}`,
      method: 'delete',
    })
    getTrackers()
  }

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value })

  return (
    <div className="p-4 mt-5 w-100 border rounded">
      <Row>
        <Col className="d-flex">
          <h4 className="my-auto">第三方追蹤碼</h4>
        </Col>
        <Col className="ms-auto d-flex" xs={2}>
          <Button className="my-auto ms-auto me-2" onClick={handleADD}>
            新增
          </Button>
        </Col>
      </Row>

      {trackers.map((t) => {
        const isEditing = editingId === t.tracker_id
        return (
          <Row key={t.tracker_id} className="my-2">
            <Col xs={10}>
              <Row>
                <Col xs={2}>
                  <Form.Label>名稱</Form.Label>
                </Col>
                <Col xs={10}>
                  <Form.Control
                    type="text"
                    name="name"
                    value={isEditing ? form.name : t.setting.name}
                    onChange={handleChange}
                    className="w-100 border p-2"
                    disabled={!isEditing}
                  />
                </Col>
              </Row>

              {/* Text (3 行高) */}
              <Row>
                <Col xs={2}>
                  <Form.Label>追蹤碼</Form.Label>
                </Col>
                <Col xs={10}>
                  <Form.Control
                    as="textarea"
                    name="text"
                    rows={3}
                    value={isEditing ? form.text : t.setting.text}
                    onChange={handleChange}
                    className="w-100 border p-2"
                    disabled={!isEditing}
                  />
                </Col>
              </Row>
            </Col>

            {/* 操作區 */}
            <Col className="d-flex" xs={2}>
              {isEditing ? (
                <>
                  <Button
                    type="button"
                    className="m-auto"
                    onClick={() => handleSave(t.tracker_id)}
                  >
                    <FontAwesomeIcon icon={faSave} />
                  </Button>
                  <Button
                    variant="danger"
                    className="m-auto"
                    type="button"
                    onClick={handleCancel}
                  >
                    <FontAwesomeIcon icon={faTimes} />
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    className="m-auto"
                    type="button"
                    onClick={() => handleEdit(t)}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </Button>
                  <Button
                    type="button"
                    variant="danger"
                    className="m-auto"
                    onClick={() => handleDelete(t.tracker_id)}
                  >
                    <FontAwesomeIcon icon={faTrashAlt} />
                  </Button>
                </>
              )}
            </Col>
          </Row>
        )
      })}

      {/* 若沒有資料顯示友善提示 */}
      {trackers.length === 0 && (
        <p className="text-center text-gray-500 py-4">
          尚無 Tracker 資料 / No trackers found
        </p>
      )}
    </div>
  )
}

function CreativeModal({ setting }) {
  const {
    show,
    creative_id,
    projectId,
    handleClose = () => {},
    handleUpload = () => {},
    handleUploadSettings = () => {},
  } = setting
  const [name, setName] = useState('')
  const [type, setType] = useState('')
  const [category, setCategory] = useState('')
  const [hasIntroAnimation, setHasIntroAnimation] = useState(false)
  const [introAnimation, setIntroAnimation] = useState(null)
  const [showIntro, setShowIntro] = useState(false)
  const [correspondImgs, setCorrespondImgs] = useState([])
  const [correspondVideos, setCorrespondVideos] = useState([])
  const [showMedia, setShowMedia] = useState(true)
  const [showFirstImage, setShowFirstImage] = useState(false)
  const [isReset, setIsReset] = useState(false)
  const [pageFlipRedirectUrl, setPageFlipRedirectUrl] = useState('')
  const [pageFlipVideoRedirectUrl, setPageFlipVideoRedirectUrl] = useState('')
  const [pageFlipImageRedirectUrl, setPageFlipImageRedirectUrl] = useState('')
  const [threeRedirectUrl1, setThreeRedirectUrl1] = useState('')
  const [threeRedirectUrl2, setThreeRedirectUrl2] = useState('')
  const [threeRedirectUrl3, setThreeRedirectUrl3] = useState('')

  const [useSplitMp4, setUseSplitMp4] = useState(true)
  const [introKey, setIntroKey] = useState(0)
  const [introResetKey, setIntroResetKey] = useState(0)
  const [device, setDevice] = useState('行動裝置')

  const [loading, setloading] = useState(false)
  const [uploadedImages, setUploadedImages] = useState([
    { label: 'Pic 1', type: 'img', file: null },
  ])
  const [srcs, setSrcs] = useState([])

  useEffect(() => {
    const initializeFromSetting = async () => {
      if (setting.type) {
        setloading(true)
      }
      const urlToFile = async (url, t = 'blob') => {
        const res = await fetch(url)
        const blob = await res.blob()
        const filename = url.split('/').pop()
        const file = new File([blob], filename, { type: blob.type })
        return t === 'file' ? file : URL.createObjectURL(file)
      }

      const convertFileList = async (arr = [], t = 'blob') =>
        Promise.all(
          arr.map(async (item) => {
            if (typeof item?.file === 'string') {
              const file = await urlToFile(item.file, t)
              return { ...item, file, preview: file }
            }
            return item
          })
        )

      const uploaded = await convertFileList(setting.srcs || [], 'file')
      const srcItems = await convertFileList(setting.srcs || [])
      const imgs = await convertFileList(setting.correspondImgs || [], 'file')
      const vids = await convertFileList(setting.correspondVideos || [])
      const intro =
        typeof setting.introAnimation === 'string'
          ? await urlToFile(setting.introAnimation)
          : setting.introAnimation

      setName(setting.name || '未命名')
      setType(setting.type || '')
      setCategory(setting.category || '')
      setHasIntroAnimation(setting.hasIntroAnimation || false)
      setIntroAnimation(intro)
      setUseSplitMp4(setting.useSplitMp4 || false)
      setShowIntro(setting.showIntro || false)
      setCorrespondImgs(imgs)
      setCorrespondVideos(vids)
      setShowMedia(setting.showMedia ?? true)
      setShowFirstImage(setting.showFirstImage || false)
      setPageFlipRedirectUrl(setting.pageFlipRedirectUrl || '')
      setPageFlipVideoRedirectUrl(setting.pageFlipVideoRedirectUrl || '')
      setPageFlipImageRedirectUrl(setting.pageFlipImageRedirectUrl || '')
      setDevice(setting.device || '行動裝置')
      setUploadedImages(
        uploaded.length
          ? uploaded
          : [{ label: 'Pic 1', type: 'img', file: null }]
      )
      setSrcs(srcItems.length ? srcItems : uploaded)
      setloading(false)
    }

    if (setting.show) initializeFromSetting()
  }, [setting.show])

  const handleCategoryChange = (e) => {
    setCategory(e.target.value)
    setType('')
  }

  const resetPreview = () => {
    setIsReset(true)
    setShowMedia(true)
    setHasIntroAnimation(false)
    setTimeout(() => {
      setHasIntroAnimation(true)
      setShowIntro(true)
    }, 10)
  }

  const desktopCategories = {
    蓋板: [''],
    文中: [
      '告示牌大橫幅廣告',
      '告示牌影音橫幅廣告',
      '文中影音廣告',
      '文中輪播',
    ],
    置底: ['置底輪播'],
  }

  const categories = {
    蓋板: ['全屏畫布', '蓋板輪播Sticky', '便利貼', '便利貼（輪播）'],
    文中: [
      '預設輪播',
      '滑動蓋板',
      '滑動蓋板（多圖）',
      '旋轉木馬',
      '互動轉盤',
      '雙面旋轉',
      '3D旋轉方塊',
      '圖中圖',
      '社群貼文',
      '左右PK',
      '視覺雙響-文中翻頁蓋板+快閃動畫',
      '魔法卡片',
    ],
    置底: [
      '行動置底展開',
      '置底-雙面旋轉',
      // '旋轉摩天輪',
      '跑馬燈',
      '展示影音',
      '包框影音',
      '旋轉方塊',
      '立體旋轉卡片',
      '置底迴廊',
      '翻玩展開',
      '拖曳互動',
      '切入式廣告',
      '切入式廣告(影片)',
      '翻書影音廣告',
      '手翻型錄廣告',
      '手翻型錄Banner廣告',
      '飛梭膠卷影音廣告',
      '置底互動轉盤',
      '開場+320H靜態廣告',
      '開場+320H動態廣告',
      '開場+320H翻玩廣告',
      '開場+320H翻玩影音廣告',
    ],
  }

  const handleTypeChange = (e) => {
    const selectedType = e.target.value
    setType(selectedType)

    if (selectedType === '展示影音') {
      setSrcs([{ label: 'Video', type: 'video', file: null }])
      setUploadedImages([{ label: 'Video', type: 'video', file: null }])
    } else if (
      selectedType === '行動置底展開' ||
      selectedType === '便利貼' ||
      selectedType === '雙面旋轉' ||
      selectedType === '置底-雙面旋轉' ||
      selectedType === '左右PK' ||
      selectedType === '蓋板輪播Sticky'
    ) {
      setSrcs([
        { label: 'Pic 1', type: 'img', file: uploadedImages[0]?.file || null },
        { label: 'Pic 2', type: 'img', file: uploadedImages[1]?.file || null },
      ])
      setUploadedImages([
        { label: 'Pic 1', type: 'img', file: uploadedImages[0]?.file || null },
        { label: 'Pic 2', type: 'img', file: uploadedImages[1]?.file || null },
      ])
    } else if (selectedType === '立體旋轉卡片') {
      setSrcs([
        {
          label: 'Pic 1*',
          type: 'img',
          file: uploadedImages[0]?.file || null,
        },
        {
          label: 'Pic 2*',
          type: 'img',
          file: uploadedImages[1]?.file || null,
        },
        {
          label: 'Pic 3*',
          type: 'img',
          file: uploadedImages[2]?.file || null,
        },
      ])
      setUploadedImages([
        { label: 'Pic 1', type: 'img', file: uploadedImages[0]?.file || null },
        { label: 'Pic 2', type: 'img', file: uploadedImages[1]?.file || null },
        { label: 'Pic 3', type: 'img', file: uploadedImages[2]?.file || null },
      ])
    } else if (selectedType === '圖中圖' || selectedType === '滑動蓋板') {
      setSrcs([
        { label: 'Pic 1', type: 'img', file: uploadedImages[0]?.file || null },
      ])
    } else if (selectedType === '互動轉盤' || selectedType === '置底互動轉盤') {
      const paddedImages = [
        uploadedImages[0]?.file ?? null,
        uploadedImages[1]?.file ?? null,
        uploadedImages[2]?.file ?? null,
        uploadedImages[3]?.file ?? null,
      ]

      setSrcs([
        { label: 'Rotate Pic', type: 'img', file: paddedImages[0] },
        { label: 'Popup A (top)', type: 'img', file: paddedImages[1] },
        { label: 'Popup B (right)', type: 'img', file: paddedImages[2] },
        { label: 'Popup C (left)', type: 'img', file: paddedImages[3] },
      ])

      setUploadedImages([
        { label: 'Rotate Pic', type: 'img', file: paddedImages[0] },
        { label: 'Popup A (top)', type: 'img', file: paddedImages[1] },
        { label: 'Popup B (right)', type: 'img', file: paddedImages[2] },
        { label: 'Popup C (left)', type: 'img', file: paddedImages[3] },
      ])
    } else if (selectedType === '包框影音') {
      setSrcs([
        { label: 'Image', type: 'img', file: uploadedImages[0]?.file || null },
        {
          label: 'Video',
          type: 'video',
          file: uploadedImages[1]?.file || null,
        },
      ])
      setUploadedImages([
        { label: 'Image', type: 'img', file: uploadedImages[0]?.file || null },
        {
          label: 'Video',
          type: 'video',
          file: uploadedImages[1]?.file || null,
        },
      ])

    } else if (selectedType === '全屏畫布') {
    setSrcs([{ label: 'Video', type: 'video', file: uploadedImages[0]?.file || null }]);
    setUploadedImages([{ label: 'Video', type: 'video', file: uploadedImages[0]?.file || null }]);

    } else if (selectedType === '開場+320H靜態廣告') {
      setSrcs([
        {
          label: 'Intro video',
          type: 'file',
          file: uploadedImages[0]?.file || null,
        },
        {
          label: 'Main img',
          type: 'img',
          file: uploadedImages[1]?.file || null,
        },
      ])
      setUploadedImages([
        {
          label: 'Intro video',
          type: 'file',
          file: uploadedImages[0]?.file || null,
        },
        {
          label: 'Main img',
          type: 'img',
          file: uploadedImages[1]?.file || null,
        },
      ])
    } else if (selectedType === '開場+320H動態廣告') {
      setSrcs([
        {
          label: 'Intro video',
          type: 'file',
          file: uploadedImages[0]?.file || null,
        },
        {
          label: 'Bottom video',
          type: 'img',
          file: uploadedImages[1]?.file || null,
        },
        {
          label: 'Top img',
          type: 'img',
          file: uploadedImages[2]?.file || null,
        },
      ])
      setUploadedImages([
        {
          label: 'Intro video',
          type: 'file',
          file: uploadedImages[0]?.file || null,
        },
        {
          label: 'Bottom video',
          type: 'img',
          file: uploadedImages[1]?.file || null,
        },
        {
          label: 'Top img',
          type: 'img',
          file: uploadedImages[2]?.file || null,
        },
      ])
    } else if (selectedType === '視覺雙響-文中翻頁蓋板+快閃動畫') {
      setSrcs([
        {
          label: 'Intro video',
          type: 'file',
          file: uploadedImages[0]?.file || null,
        },
        {
          label: 'Bottom video',
          type: 'file',
          file: uploadedImages[1]?.file || null,
        },
        {
          label: 'Pic 1',
          type: 'img',
          file: uploadedImages[2]?.file || null,
        },
        {
          label: 'Pic 2',
          type: 'img',
          file: uploadedImages[3]?.file || null,
        },
        {
          label: 'Pic 3',
          type: 'img',
          file: uploadedImages[4]?.file || null,
        },
      ])
      setUploadedImages([
        {
          label: 'Intro video',
          type: 'file',
          file: uploadedImages[0]?.file || null,
        },
        {
          label: 'Bottom video',
          type: 'file',
          file: uploadedImages[1]?.file || null,
        },
        {
          label: 'Pic 1',
          type: 'img',
          file: uploadedImages[2]?.file || null,
        },
        {
          label: 'Pic 2',
          type: 'img',
          file: uploadedImages[3]?.file || null,
        },
        {
          label: 'Pic 3',
          type: 'img',
          file: uploadedImages[4]?.file || null,
        },
      ])
    } else if (selectedType === '魔法卡片') {
      setSrcs([
        {
          label: 'Intro video',
          type: 'file',
          file: uploadedImages[0]?.file || null,
        },
        {
          label: 'Pic 1',
          type: 'img',
          file: uploadedImages[1]?.file || null,
        },
        {
          label: 'Pic 2',
          type: 'img',
          file: uploadedImages[2]?.file || null,
        },
        {
          label: 'Pic 3',
          type: 'img',
          file: uploadedImages[3]?.file || null,
        },
      ])
      setUploadedImages([
        {
          label: 'Intro video',
          type: 'file',
          file: uploadedImages[0]?.file || null,
        },
        {
          label: 'Pic 1',
          type: 'img',
          file: uploadedImages[1]?.file || null,
        },
        {
          label: 'Pic 2',
          type: 'img',
          file: uploadedImages[2]?.file || null,
        },
        {
          label: 'Pic 3',
          type: 'img',
          file: uploadedImages[3]?.file || null,
        },
      ])
    } else if (selectedType === '開場+320H翻玩廣告') {
      setSrcs([
        {
          label: 'Intro video',
          type: 'file',
          file: uploadedImages[0]?.file || null,
        },
        {
          label: 'Pic 1',
          type: 'img',
          file: uploadedImages[1]?.file || null,
        },
        {
          label: 'Pic 2',
          type: 'img',
          file: uploadedImages[2]?.file || null,
        },
        {
          label: 'Pic 3',
          type: 'img',
          file: uploadedImages[3]?.file || null,
        },
        {
          label: 'Pic 4',
          type: 'img',
          file: uploadedImages[4]?.file || null,
        },
      ])
      setUploadedImages([
        {
          label: 'Intro video',
          type: 'file',
          file: uploadedImages[0]?.file || null,
        },
        {
          label: 'Pic 1',
          type: 'img',
          file: uploadedImages[1]?.file || null,
        },
        {
          label: 'Pic 2',
          type: 'img',
          file: uploadedImages[2]?.file || null,
        },
        {
          label: 'Pic 3',
          type: 'img',
          file: uploadedImages[3]?.file || null,
        },
        {
          label: 'Pic 4',
          type: 'img',
          file: uploadedImages[4]?.file || null,
        },
      ])
    } else if (selectedType === '開場+320H翻玩影音廣告') {
      setSrcs([
        {
          label: 'Intro video',
          type: 'file',
          file: uploadedImages[0]?.file || null,
        },
        {
          label: 'Bottom video',
          type: 'file',
          file: uploadedImages[1]?.file || null,
        },
        {
          label: 'Pic 1',
          type: 'img',
          file: uploadedImages[2]?.file || null,
        },
        {
          label: 'Pic 2',
          type: 'img',
          file: uploadedImages[3]?.file || null,
        },
        {
          label: 'Pic 3',
          type: 'img',
          file: uploadedImages[4]?.file || null,
        },
      ])
      setUploadedImages([
        {
          label: 'Intro video',
          type: 'file',
          file: uploadedImages[0]?.file || null,
        },
        {
          label: 'Bottom video',
          type: 'file',
          file: uploadedImages[1]?.file || null,
        },
        {
          label: 'Pic 1',
          type: 'img',
          file: uploadedImages[2]?.file || null,
        },
        {
          label: 'Pic 2',
          type: 'img',
          file: uploadedImages[3]?.file || null,
        },
        {
          label: 'Pic 3',
          type: 'img',
          file: uploadedImages[4]?.file || null,
        },
      ])
    } else if (selectedType === '拖曳互動') {
      setSrcs([
        {
          label: 'Before img',
          type: 'img',
          file: uploadedImages[0]?.file || null,
        },
        {
          label: 'After img',
          type: 'img',
          file: uploadedImages[1]?.file || null,
        },
        {
          label: 'Drag img',
          type: 'img',
          file: uploadedImages[2]?.file || null,
        },
        {
          label: 'Banner Video or Img',
          type: uploadedImages[3]?.file?.type?.startsWith('video')
            ? 'video'
            : 'img',
          file: uploadedImages[3]?.file || null,
        },
        {
          label: 'Expand Img',
          type: 'img',
          file: uploadedImages[4]?.file || null,
        },
        {
          label: 'Expand Video',
          type: 'video',
          file: uploadedImages[5]?.file || null,
        },
      ])

      setUploadedImages([
        {
          label: 'Before img',
          type: 'img',
          file: uploadedImages[0]?.file || null,
        },
        {
          label: 'After img',
          type: 'img',
          file: uploadedImages[1]?.file || null,
        },
        {
          label: 'Drag img',
          type: 'img',
          file: uploadedImages[2]?.file || null,
        },
        {
          label: 'Banner Video or Img',
          type: uploadedImages[3]?.file?.type?.startsWith('video')
            ? 'video'
            : 'img',
          file: uploadedImages[3]?.file || null,
        },
        {
          label: 'Expand Img',
          type: 'img',
          file: uploadedImages[4]?.file || null,
        },
        {
          label: 'Expand Video',
          type: 'video',
          file: uploadedImages[5]?.file || null,
        },
      ])
    } else if (selectedType === '切入式廣告') {
      setSrcs([
        {
          label: 'Background Img',
          type: 'img',
          file: uploadedImages[0]?.file || null,
        },
        {
          label: 'Left 1',
          type: 'img',
          file: uploadedImages[1]?.file || null,
        },
        {
          label: 'Left 2',
          type: 'img',
          file: uploadedImages[2]?.file || null,
        },
        {
          label: 'Right 1',
          type: 'img',
          file: uploadedImages[3]?.file || null,
        },
        {
          label: 'Right 2',
          type: 'img',
          file: uploadedImages[4]?.file || null,
        },
      ])
      setUploadedImages([
        {
          label: 'Background Img',
          type: 'img',
          file: uploadedImages[0]?.file || null,
        },
        {
          label: 'Left 1',
          type: 'img',
          file: uploadedImages[1]?.file || null,
        },
        {
          label: 'Left 2',
          type: 'img',
          file: uploadedImages[2]?.file || null,
        },
        {
          label: 'Right 1',
          type: 'img',
          file: uploadedImages[3]?.file || null,
        },
        {
          label: 'Right 2',
          type: 'img',
          file: uploadedImages[4]?.file || null,
        },
      ])
    } else if (selectedType === '手翻型錄廣告') {
      setSrcs([
        {
          label: 'Bottom img',
          type: 'img',
          file: uploadedImages[0]?.file || null,
        },
        {
          label: 'Top img 1',
          type: 'img',
          file: uploadedImages[1]?.file || null,
        },
        {
          label: 'Top img 2',
          type: 'img',
          file: uploadedImages[2]?.file || null,
        },
        {
          label: 'Top img 3',
          type: 'img',
          file: uploadedImages[3]?.file || null,
        },
      ])
      setUploadedImages([
        {
          label: 'Bottom img',
          type: 'img',
          file: uploadedImages[0]?.file || null,
        },
        {
          label: 'Top img 1',
          type: 'img',
          file: uploadedImages[1]?.file || null,
        },
        {
          label: 'Top img 2',
          type: 'img',
          file: uploadedImages[2]?.file || null,
        },
        {
          label: 'Top img 3',
          type: 'img',
          file: uploadedImages[3]?.file || null,
        },
      ])
    } else if (selectedType === '手翻型錄Banner廣告') {
      setSrcs([
        {
          label: 'Intro video',
          type: 'file',
          file: uploadedImages[0]?.file || null,
        },
        {
          label: 'Bottom img',
          type: 'img',
          file: uploadedImages[1]?.file || null,
        },
        {
          label: 'Right img 1',
          type: 'img',
          file: uploadedImages[2]?.file || null,
        },
        {
          label: 'Right img 2',
          type: 'img',
          file: uploadedImages[3]?.file || null,
        },
        {
          label: 'Right img 3',
          type: 'img',
          file: uploadedImages[4]?.file || null,
        },
        {
          label: 'Right img 4',
          type: 'img',
          file: uploadedImages[5]?.file || null,
        },
        {
          label: 'Expand img 1',
          type: 'img',
          file: uploadedImages[6]?.file || null,
        },
        {
          label: 'Expand img 2',
          type: 'img',
          file: uploadedImages[7]?.file || null,
        },
        {
          label: 'Expand img 3',
          type: 'img',
          file: uploadedImages[8]?.file || null,
        },
        {
          label: 'Expand img 4',
          type: 'img',
          file: uploadedImages[9]?.file || null,
        },
      ])
      setUploadedImages([
        {
          label: 'Intro video',
          type: 'file',
          file: uploadedImages[0]?.file || null,
        },
        {
          label: 'Bottom img',
          type: 'img',
          file: uploadedImages[1]?.file || null,
        },
        {
          label: 'Right img 1',
          type: 'img',
          file: uploadedImages[2]?.file || null,
        },
        {
          label: 'Right img 2',
          type: 'img',
          file: uploadedImages[3]?.file || null,
        },
        {
          label: 'Right img 3',
          type: 'img',
          file: uploadedImages[4]?.file || null,
        },
        {
          label: 'Right img 4',
          type: 'img',
          file: uploadedImages[5]?.file || null,
        },
        {
          label: 'Expand img 1',
          type: 'img',
          file: uploadedImages[6]?.file || null,
        },
        {
          label: 'Expand img 2',
          type: 'img',
          file: uploadedImages[7]?.file || null,
        },
        {
          label: 'Expand img 3',
          type: 'img',
          file: uploadedImages[8]?.file || null,
        },
        {
          label: 'Expand img 4',
          type: 'img',
          file: uploadedImages[9]?.file || null,
        },
      ])
    } else if (
      selectedType === '切入式廣告(影片)' ||
      selectedType === '翻書影音廣告'
    ) {
      setSrcs([
        {
          label: 'Background Img',
          type: 'img',
          file: uploadedImages[0]?.file || null,
        },
        {
          label: 'Left Video',
          type: 'video',
          file: uploadedImages[1]?.file || null,
        },
        {
          label: 'Right Img 1',
          type: 'img',
          file: uploadedImages[2]?.file || null,
        },
        {
          label: 'Right Img 2',
          type: 'img',
          file: uploadedImages[3]?.file || null,
        },
        {
          label: 'Right Img 3',
          type: 'img',
          file: uploadedImages[4]?.file || null,
        },
      ])

      setUploadedImages([
        {
          label: 'Background Img',
          type: 'img',
          file: uploadedImages[0]?.file || null,
        },
        {
          label: 'Left Video',
          type: 'video',
          file: uploadedImages[1]?.file || null,
        },
        {
          label: 'Right Img 1',
          type: 'img',
          file: uploadedImages[2]?.file || null,
        },
        {
          label: 'Right Img 2',
          type: 'img',
          file: uploadedImages[3]?.file || null,
        },
        {
          label: 'Right Img 3',
          type: 'img',
          file: uploadedImages[4]?.file || null,
        },
      ])
      // 桌機版版位
    } else if (selectedType === '告示牌大橫幅廣告') {
      setSrcs([
        {
          label: 'Background img',
          type: 'img',
          file: uploadedImages[0]?.file || null,
        },
      ])
      setUploadedImages([
        {
          label: 'Background img',
          type: 'img',
          file: uploadedImages[0]?.file || null,
        },
      ])
    } else if (selectedType === '告示牌影音橫幅廣告') {
      setSrcs([
        {
          label: 'Left video',
          type: 'video',
          file: uploadedImages[0]?.file || null,
        },
        {
          label: 'Background img',
          type: 'img',
          file: uploadedImages[1]?.file || null,
        },
      ])
      setUploadedImages([
        {
          label: 'Left video',
          type: 'video',
          file: uploadedImages[0]?.file || null,
        },
        {
          label: 'Background img',
          type: 'img',
          file: uploadedImages[1]?.file || null,
        },
      ])
    } else if (selectedType === '文中影音廣告') {
      setSrcs([
        {
          label: 'Video or Image',
          type: 'file',
          file: uploadedImages[0]?.file || null,
        },
      ])
      setUploadedImages([
        {
          label: 'Video or Image',
          type: 'file',
          file: uploadedImages[0]?.file || null,
        },
      ])
    } else {
      setSrcs(
        uploadedImages.map((image, index) => ({
          label: `Pic ${index + 1}`,
          type: 'img',
          file: image?.file || null,
        }))
      )
    }
  }

  const handleFileChange = (e, index) => {
    const file = e.target.files[0]
    if (file) {
      const updatedImages = [...uploadedImages]
      updatedImages[index] = {
        ...updatedImages[index],
        file,
        type: file.type,
      }

      setUploadedImages(updatedImages)

      if (type === '展示影音') {
        setSrcs([
          {
            label: 'Video',
            type: 'video',
            file,
            key: URL.createObjectURL(file),
          },
        ])
      } else if (type === '包框影音') {
        setSrcs([
          {
            label: 'Image',
            type: 'img',
            file: updatedImages[0]?.file || null,
          },
          {
            label: 'Video',
            type: 'video',
            file: updatedImages[1]?.file || null,
            key: updatedImages[1]?.file
              ? URL.createObjectURL(updatedImages[1]?.file)
              : null,
          },
        ])
      } else if (
        type === '圖中圖' ||
        type === '滑動蓋板' ||
        type === '全屏畫布'
      ) {
        setSrcs([updatedImages[0]])
      } else if (type === '行動置底展開') {
        setSrcs([
          updatedImages[0],
          updatedImages[1] || { label: 'Pic 2', type: 'img', file: null },
        ])
      } else if (type === '拖曳互動' || type === '手翻型錄廣告') {
        setSrcs(updatedImages)
      } else {
        setSrcs(
          updatedImages.map((img) => ({
            ...img,
            file: img.file ? URL.createObjectURL(img.file) : null,
          }))
        )
      }
    }
  }

  const addUploadField = () => {
    if (
      type !== '行動置底展開' &&
      type !== '圖中圖' &&
      type !== '雙面旋轉' &&
      type !== '置底-雙面旋轉' &&
      type !== '左右PK' &&
      type !== '互動轉盤'
    ) {
      const isBookAd = type === '翻書影音廣告'
      const isMoveinVideo = type === '切入式廣告(影片)'

      const rightImgCount = uploadedImages.filter((img) =>
        isBookAd || isMoveinVideo ? img.label?.startsWith('Right Img') : false
      ).length

      const newImage = {
        label:
          isBookAd || isMoveinVideo
            ? `Right Img ${rightImgCount + 1}`
            : `Pic ${uploadedImages.length + 1}`,
        type: 'img',
        file: null,
      }

      const newList = [...uploadedImages, newImage]
      setUploadedImages(newList)
      setSrcs(newList)
    }
  }

  const [likes, setLikes] = useState('')
  const [comments, setComments] = useState('')
  const [shares, setShares] = useState('')
  const [postText, setPostText] = useState('')
  const [titleText, setTitleText] = useState('')

  const [boldTexts, setBoldTexts] = useState([])
  const [contentTexts, setContentTexts] = useState([])
  const [btnTexts, setBtnTexts] = useState([])

  const handleCorrespondImgChange = (e, index) => {
    const file = e.target.files[0]
    if (file) {
      const newCorrespondImgs = [...correspondImgs]
      newCorrespondImgs[index] = {
        ...newCorrespondImgs[index],
        file,
        preview: URL.createObjectURL(file),
      }
      setCorrespondImgs(newCorrespondImgs)
    }
  }

  const handleCorrespondVideoChange = (e, index) => {
    const file = e.target.files[0]
    if (file) {
      const newCorrespondVideos = [...correspondVideos]
      newCorrespondVideos[index] = {
        ...newCorrespondVideos[index],
        file,
        preview: URL.createObjectURL(file),
        type: file.type.startsWith('video/') ? 'video' : 'unknown',
      }
      setCorrespondVideos(newCorrespondVideos)
    }
  }

  const renderPreview = () => {
    const previewComponent = (() => {
      if (device === '桌機') {
        switch (type) {
          case '告示牌大橫幅廣告':
            return (
              <DesktopBannerPreview
                srcs={srcs}
                redirectUrl={pageFlipRedirectUrl}
              />
            )

          case '告示牌影音橫幅廣告':
            return (
              <DesktopVideoBannerPreview
                srcs={srcs}
                redirectUrl={pageFlipRedirectUrl}
              />
            )

          case '文中影音廣告':
            return (
              <DesktopContentPreview
                srcs={srcs}
                redirectUrl={pageFlipRedirectUrl}
              />
            )

          case '文中輪播':
            return (
              <DesktopContentCarousel
                srcs={srcs}
                redirectUrl={pageFlipRedirectUrl}
              />
            )

          case '置底輪播':
            return (
              <DesktopStickyCarousel
                srcs={srcs}
                redirectUrl={pageFlipRedirectUrl}
              />
            )

          default:
            return (
              <div className="text-muted text-center pt-3">請選擇版位內容</div>
            )
        }
      }

      switch (type) {
        case '預設輪播':
          return (
            <DefaultCarouselPreview
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              srcs={srcs}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
              redirectUrl={pageFlipRedirectUrl}
            />
          )
        case '旋轉木馬':
          return (
            <CarouselPreview
              srcs={srcs}
              boldTexts={boldTexts}
              contentTexts={contentTexts}
              btnTexts={btnTexts}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
              redirectUrl={pageFlipRedirectUrl}
            />
          )
        case '互動轉盤':
          return (
            <PizzaPreview
              srcs={srcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
            />
          )
        case '置底互動轉盤':
          return (
            <PizzaStickyPreview
              srcs={srcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
              key={introKey}
              redirectUrls={{
                url1: threeRedirectUrl1,
                url2: threeRedirectUrl2,
                url3: threeRedirectUrl3,
              }}
            />
          )
        case '蓋板輪播Sticky':
          return (
            <CarouselStickyPreview
              srcs={srcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
              redirectUrl={pageFlipRedirectUrl}
            />
          )
        case '行動置底展開':
          return (
            <StickyAdPreview
              srcs={srcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
              key={introKey}
              redirectUrl={pageFlipRedirectUrl}
            />
          )
        case '跑馬燈':
          return (
            <MarqueePreview
              srcs={srcs}
              setSrcs={setSrcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
              key={introKey}
              redirectUrl={pageFlipRedirectUrl}
            />
          )
        case '開場+320H靜態廣告':
          return (
            <IntroWith320HStaticPreview
              srcs={srcs}
              setSrcs={setSrcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
              resetKey={introResetKey}
              redirectUrl={pageFlipRedirectUrl}
            />
          )
        case '開場+320H動態廣告':
          return (
            <IntroWith320HDynamicPreview
              srcs={srcs}
              setSrcs={setSrcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
              resetKey={introResetKey}
              redirectImage={pageFlipImageRedirectUrl}
              redirectVideo={pageFlipVideoRedirectUrl}
            />
          )
        case '開場+320H翻玩廣告':
          return (
            <IntroWith320HCirclePreview
              srcs={srcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
              correspondImgs={correspondImgs}
              resetKey={introResetKey}
              redirectUrl={pageFlipRedirectUrl}
            />
          )
        case '開場+320H翻玩影音廣告':
          return (
            <IntroWith320HCircleVideoPreview
              srcs={srcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
              correspondImgs={correspondImgs}
              resetKey={introResetKey}
              redirectImage={pageFlipImageRedirectUrl}
              redirectVideo={pageFlipVideoRedirectUrl}
            />
          )
        case '圖中圖':
          return (
            <PictureInPicturePreview
              srcs={srcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
              redirectUrl={pageFlipRedirectUrl}
            />
          )
        case '便利貼':
          return (
            <NotePreview
              srcs={srcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
              redirectUrl={pageFlipRedirectUrl}
            />
          )
        case '便利貼（輪播）':
          return (
            <NoteCarouselPreview
              srcs={srcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
              redirectUrl={pageFlipRedirectUrl}
            />
          )
        case '滑動蓋板':
          return (
            <SlidingCoverPreview
              srcs={srcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
              redirectUrl={pageFlipRedirectUrl}
            />
          )
        case '滑動蓋板（多圖）':
          return (
            <SlidingCoverMultiPreview
              srcs={srcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
              redirectUrl={pageFlipRedirectUrl}
            />
          )
        case '翻玩展開':
          return (
            <RotateCirclePreview
              srcs={srcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
              correspondImgs={correspondImgs}
              isReset={isReset}
              redirectUrl={pageFlipRedirectUrl}
              correspondVideos={correspondVideos}
            />
          )
        case '視覺雙響-文中翻頁蓋板+快閃動畫':
          return (
            <SlidingCoverMultiStickyPreview
              srcs={srcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
              setShowFirstImage={setShowFirstImage}
              showFirstImage={showFirstImage}
              isReset={isReset}
              redirectImage={pageFlipImageRedirectUrl}
              redirectVideo={pageFlipVideoRedirectUrl}
            />
          )
        case '魔法卡片':
          return (
            <MagicCardPreview
              srcs={srcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
              setShowFirstImage={setShowFirstImage}
              showFirstImage={showFirstImage}
              isReset={isReset}
              redirectUrl={pageFlipRedirectUrl}
            />
          )
        case '雙面旋轉':
          return (
            <DoubleRotatePreview
              srcs={srcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
            />
          )
        case '置底-雙面旋轉':
          return (
            <DoubleRotateVerticalPreview
              srcs={srcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
              redirectUrl={pageFlipRedirectUrl}
            />
          )
        // case '旋轉摩天輪':
        //   return (
        //     <RotateFerrisWheelPreview
        //       srcs={srcs}
        //       hasIntroAnimation={hasIntroAnimation}
        //       introAnimation={introAnimation}
        //       setHasIntroAnimation={setHasIntroAnimation}
        //       isMediaVisible={showMedia}
        //       setFullScreenShowMedia={setShowMedia}
        //     />
        //   )
        case '3D旋轉方塊':
          return (
            <RotateCubePreview
              srcs={srcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
            />
          )
        case '旋轉方塊':
          return (
            <RotateCubeStickyPreview
              srcs={srcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
            />
          )
        case '展示影音':
          return (
            <ShowVideoPreview
              srcs={srcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
              redirectUrl={pageFlipRedirectUrl}
            />
          )
        case '包框影音':
          return (
            <ImageAndVideoPreview
              srcs={srcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
              redirectImage={pageFlipImageRedirectUrl}
              redirectVideo={pageFlipVideoRedirectUrl}
            />
          )
        case '立體旋轉卡片':
          return (
            <CoverflowPreview
              srcs={srcs}
              setSrcs={setSrcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
            />
          )
        case '置底迴廊':
          return (
            <CoverflowCirclePreview
              srcs={srcs}
              setSrcs={setSrcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
              redirectUrl={pageFlipRedirectUrl}
            />
          )
        case '切入式廣告':
          return (
            <MoveinPreview
              srcs={srcs}
              setSrcs={setSrcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
              redirectUrl={pageFlipRedirectUrl}
            />
          )
        case '切入式廣告(影片)':
          return (
            <MoveinVideoPreview
              srcs={srcs}
              setSrcs={setSrcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
              redirectImage={pageFlipImageRedirectUrl}
              redirectVideo={pageFlipVideoRedirectUrl}
            />
          )
        case '翻書影音廣告':
          return (
            <BookWithVideoPreview
              srcs={srcs}
              setSrcs={setSrcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
              redirectImage={pageFlipImageRedirectUrl}
              redirectVideo={pageFlipVideoRedirectUrl}
            />
          )
        case '手翻型錄廣告':
          return (
            <PageFlipPreview
              srcs={srcs}
              setSrcs={setSrcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
              redirectUrl={pageFlipRedirectUrl}
            />
          )
        case '手翻型錄Banner廣告':
          return (
            <PageFlipWithBannerPreview
              srcs={srcs}
              setSrcs={setSrcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
              redirectUrl={pageFlipRedirectUrl}
              isReset={isReset}
            />
          )
        case '左右PK':
          return (
            <TwentytwentyPreview
              srcs={srcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
            />
          )
        case '拖曳互動':
          return (
            <DragChangePreview
              srcs={srcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
              isReset={isReset}
              redirectImage={pageFlipImageRedirectUrl}
              redirectVideo={pageFlipVideoRedirectUrl}
            />
          )

        case '飛梭膠卷影音廣告':
          return (
            <CarouselFilmPreview
              srcs={srcs}
              key={introKey}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
              correspondVideos={correspondVideos}
              redirectUrl={pageFlipRedirectUrl}
              showIntro
            />
          )
        case '全屏畫布':
          return (
            <FullScreenPreview
              srcs={srcs}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
              redirectUrl={pageFlipRedirectUrl}
            />
          )
        case '社群貼文':
          return (
            <SocialPostPreview
              srcs={srcs}
              title={titleText}
              text={postText}
              likes={likes}
              comments={comments}
              shares={shares}
              hasIntroAnimation={hasIntroAnimation}
              introAnimation={introAnimation}
              setHasIntroAnimation={setHasIntroAnimation}
              isMediaVisible={showMedia}
              setFullScreenShowMedia={setShowMedia}
            />
          )
        default:
          return (
            <div className="d-flex m-auto text-secondary small">
              <div
                className="position-absolute"
                style={{ right: '25%', top: '40%' }}
              >
                請選擇版位內容
              </div>
            </div>
          )
      }
    })()

    return (
      <div className="preview-container">
        <div className="preview-content">{previewComponent}</div>
        {device === '行動裝置' &&
          hasIntroAnimation &&
          introAnimation &&
          showIntro && (
            <div className="intro-overlay">
              <IntroAnimation
                file={introAnimation}
                onClose={() => setShowIntro(false)}
              />
            </div>
          )}
      </div>
    )
  }

  useEffect(() => {
    if (srcs.length > 0) {
      setBoldTexts((prev) => [
        ...prev.slice(0, srcs.length),
        ...new Array(Math.max(0, srcs.length - prev.length)).fill(''),
      ])
      setContentTexts((prev) => [
        ...prev.slice(0, srcs.length),
        ...new Array(Math.max(0, srcs.length - prev.length)).fill(''),
      ])
      setBtnTexts((prev) => [
        ...prev.slice(0, srcs.length),
        ...new Array(Math.max(0, srcs.length - prev.length)).fill(''),
      ])
    }
  }, [srcs])

  useEffect(() => {
    if (hasIntroAnimation) {
      setShowIntro(true)
    }
  }, [hasIntroAnimation])

  useEffect(() => {
    if (hasIntroAnimation && introAnimation) {
      setShowIntro(true)
    }
  }, [hasIntroAnimation, introAnimation])

  useEffect(() => {
    if (category === '置底') {
      setHasIntroAnimation(false)
    } else {
      setHasIntroAnimation(false)
      setIntroAnimation(null)
      setShowIntro(false)
    }
  }, [category])

  const [iframeSrcDoc, setIframeSrcDoc] = useState('')
  const frameContainerRef = useRef()
  useEffect(() => {
    const generateSrcDoc = async () => {
      if (!type) {
        setIframeSrcDoc('')
        return
      }

      // Convert all File objects and existing blob URLs to new blob URLs for the iframe
      const convertToBlobUrls = async (items) =>
        Promise.all(
          (items || []).map(async (item) => {
            if (item?.file instanceof File) {
              return { ...item, file: URL.createObjectURL(item.file) }
            }
            if (
              typeof item?.file === 'string' &&
              item.file.startsWith('blob:')
            ) {
              // Revoke old blob URL if it exists and create a new one
              const res = await fetch(item.file)
              const blob = await res.blob()
              // URL.revokeObjectURL(item.file)
              return { ...item, file: URL.createObjectURL(blob) }
            }
            return item // Keep existing URLs or nulls
          })
        )

      const blobSrcs = await convertToBlobUrls(srcs)
      const blobCorrespondImgs = await convertToBlobUrls(
        correspondImgs.map((item) => ({ ...item, file: item.preview }))
      ) // Use preview for conversion
      const blobCorrespondVideos = await convertToBlobUrls(
        correspondVideos.map((item) => ({ ...item, file: item.preview }))
      ) // Use preview for conversion
      const blobIntroAnimation =
        introAnimation instanceof File
          ? URL.createObjectURL(introAnimation)
          : typeof introAnimation === 'string' &&
            introAnimation.startsWith('blob:')
          ? await fetch(introAnimation)
              .then((res) => res.blob())
              .then((blob) => URL.createObjectURL(blob))
          : introAnimation

      const payload = {
        name,
        type,
        category,
        hasIntroAnimation,
        introAnimation: blobIntroAnimation,
        showIntro,
        correspondImgs: blobCorrespondImgs.map((item) => ({
          ...item,
          preview: item.file,
        })), // Restore preview field
        correspondVideos: blobCorrespondVideos.map((item) => ({
          ...item,
          preview: item.file,
        })), // Restore preview field
        showMedia,
        showFirstImage,
        pageFlipRedirectUrl,
        device,
        srcs: blobSrcs, // Use blob URLs for srcs
        likes,
        comments,
        shares,
        postText,
        titleText,
        boldTexts,
        contentTexts,
        btnTexts,
        pageFlipImageRedirectUrl,
        pageFlipVideoRedirectUrl,
      }

      const jsModule = jsModuleTypes[type] || 'default' // Fallback to 'default'
      const size = frameContainerRef.current ? {
        height: frameContainerRef.current.clientHeight,
        width: parseInt((frameContainerRef.current.clientHeight / 785) * 425, 10),
      } : {
        height: 0,
        width: 0,
      }
      console.log('===payload for iframe tester===')
      console.log(JSON.stringify(payload))

      const htmlContent = `
      <style>
        html, body {
          margin: 0;
          padding: 0;
          width: 100%;
          overflow: hidden;
        }
        body::-webkit-scrollbar {
          display: none;
        }
      </style>
      <div style="position:relative;margin: auto;width:${size.width}px; height:${size.height}px;">
      <div style="position:absolute;width:${size.width}px; height:${size.height}px;z-index: 1;pointer-events: none; background: url('https://aquarium.punwave.com/api/assets/mobile_border.png') no-repeat center/contain; display:flex; margin:auto;"></div>
        <iframe id="ad-frame" style="position:absolute;width:${size.width - 62}px; height:${size.height - 50}px;left:31px;top:30px; border:none;margin:auto;"></iframe>
      </div>
      <script>
        const iframe = document.getElementById('ad-frame');

        iframe.onload = function() {
        const iframeDoc = iframe.contentWindow.document; // 獲取 iframe 內部的 document
        const iframeHtml = iframeDoc.documentElement; // 獲取 iframe 內部的 <html> 元素
          // 設置 overflow-x 和 width
          iframeHtml.style.width = '100%';
          iframeHtml.style.overflowX = 'hidden';
          iframeHtml.style.overflowY = 'auto';
        };
        const doc = iframe.contentWindow.document;
        const content = \`<style>
          html, body {
            margin: 0;
            padding: 0;
            width: 100%;
            overflow-x: clip;   /* no horizontal scroll bar            */;
            touch-action: pan-y;  /* 行動裝置只允許垂直手勢，阻止左‧右滑  */
          }
          .text-title { height: 15px; width: 90%; background: #e7e7e7; border-radius: 5px; margin:10px auto; }
          .text-line  { height:  7px; width: 90%; background: #e7e7e7; margin:6px auto; }
          .text-ban1  { height: 200px; width: 90%; background: #e7e7e7; margin:14px auto; }
          .text-line2 { height:  7px; width: 60%; background: #e7e7e7; margin:6px auto; }
        </style>
        <div style="position: relative;">
          <div style="display: flex; border-bottom: 1px solid #dee2e6; width: 100%; height: 55px; z-index: 0; margin-bottom: 1rem; padding-bottom: 1rem; padding-top: 1rem">
            <div style="flex: 0 0 80%; display: flex; align-items: center; justify-content: flex-start; padding-left: 1rem;">
              <img src="https://www.wavenet.com.tw/wp-content/uploads/2019/02/wavnet-logo-b-s.jpg" style="width: 75%;" alt="Wavenet Logo" />
            </div>
            <div style="flex: 0 0 20%; display: flex; align-items: center; justify-content: center;">
              <i class="fa-solid fa-bars" style="text-align: end;"></i>
            </div>
          </div>

          <div class="text-title"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-ban1"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line2"></div>
          <br />
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <br />
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <br />
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <br />
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <br />
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
        </div>

        <!-- 模擬 gam 嵌入碼顯示於網頁上的效果 (1x1 iframe 的廣告素材) -->
        <iframe
          id="ads-iframe"
          src="api/bundle-ads.html"
          style="width: 1px; height: 1px; border: none"
        ></iframe>

        <div style="position: relative; height: auto; overflow-y: auto; overflow-x: hidden; background-color: #fff;">
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line2"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <br />
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <br />
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <br />
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <br />
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <br />
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
        </div>

        <script>
          // 當 iframe 內容載入完成後執行
          const adsIframe = document.getElementById('ads-iframe');
          document.getElementById('ads-iframe').onload = function() {
            const iframeDoc = adsIframe.contentDocument || adsIframe.contentWindow.document;
            const script = iframeDoc.createElement('script');
            script.async = true;
            script.text = 'var parentWindow = window.parent;var parentDoc = parentWindow.document;var adRoot = parentDoc.createElement("div");adRoot.id = "ad-root";parentDoc.body.appendChild(adRoot);parentWindow.adSetting = ${JSON.stringify(payload)};var s = document.createElement("script");s.src = "/api/scripts/${jsModule}.js";s.async = true;const frameEl = window.frameElement;try { parentDoc.body.insertBefore(s, window.frameElement)} catch (e) {parentDoc.body.appendChild(s);}'
            iframeDoc.head.appendChild(script);
          };
        </\` + 'script>'
        doc.open();
        doc.write(content);
        doc.close();
      </script>
      `

      const inreadContent = `
      <style>
        html, body {
          margin: 0;
          padding: 0;
          width: 100%;
          overflow: hidden;
        }
        body::-webkit-scrollbar {
          display: none;
        }
      </style>
      <div style="position:relative;margin: auto;width:${size.width}px; height:${size.height}px;">
      <div style="position:absolute;width:${size.width}px; height:${size.height}px;z-index: 1;pointer-events: none; background: url('https://aquarium.punwave.com/api/assets/mobile_border.png') no-repeat center/contain; display:flex; margin:auto;"></div>
        <iframe id="ad-frame" style="position:absolute;width:${size.width - 62}px; height:${size.height - 50}px;left:31px;top:30px; border:none;margin:auto;"></iframe>
      </div>
      <script>
        const iframe = document.getElementById('ad-frame');

        iframe.onload = function() {
        const iframeDoc = iframe.contentWindow.document; // 獲取 iframe 內部的 document
        const iframeHtml = iframeDoc.documentElement; // 獲取 iframe 內部的 <html> 元素
          // 設置 overflow-x 和 width
          iframeHtml.style.width = '100%';
          iframeHtml.style.overflowX = 'hidden';
          iframeHtml.style.overflowY = 'auto';
        };
        const doc = iframe.contentWindow.document;
        const content = \`<style>
          html, body {
            margin: 0;
            padding: 0;
            width: 100%;
            overflow-x: clip;   /* no horizontal scroll bar            */;
            touch-action: pan-y;  /* 行動裝置只允許垂直手勢，阻止左‧右滑  */
          }
          .text-title { height: 15px; width: 90%; background: #e7e7e7; border-radius: 5px; margin:10px auto; }
          .text-line  { height:  7px; width: 90%; background: #e7e7e7; margin:6px auto; }
          .text-ban1  { height:100px; width: 90%; background: #e7e7e7; margin:14px auto; }
          .text-line2 { height:  7px; width: 60%; background: #e7e7e7; margin:6px auto; }
          .glass-panel {
            height: 100vh;
            width: 100vw;
            pointer-events: none;
            z-index: 2;
          }
        </style>
        <div style="z-index: 2;position: relative; height: auto; overflow-y: auto; overflow-x: hidden; background-color: #fff">
          <div style="display: flex; border-bottom: 1px solid #dee2e6; width: 300px; height: 55px; z-index: 0; margin-bottom: 1rem;">
            <div style="flex: 0 0 80%; display: flex; align-items: center; justify-content: flex-start; padding-left: 1rem;">
              <img src="https://www.wavenet.com.tw/wp-content/uploads/2019/02/wavnet-logo-b-s.jpg" style="width: 75%;" alt="Wavenet Logo" />
            </div>
            <div style="flex: 0 0 20%; display: flex; align-items: center; justify-content: center;">
              <i class="fa-solid fa-bars" style="text-align: end;"></i>
            </div>
          </div>
          <div class="text-title"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-ban1"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line2"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <br />
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <br />
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <br />
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <br />
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <br />
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
        </div>

        <!-- 模擬 gam 嵌入碼顯示於網頁上的效果 (1x1 iframe 的廣告素材) -->
        <div class="glass-panel">
          <iframe
            id="ads-iframe"
            src="api/bundle-ads.html"
            style="width: 1px; height: 1px; border: none"
          ></iframe>
        </div>

        <div style="z-index: 2;position: relative; height: auto; overflow-y: auto; overflow-x: hidden; background-color: #fff; padding-top: 2rem">
          <div class="text-title"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-ban1"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line2"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <br />
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <br />
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <br />
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <br />
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <br />
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
        </div>

        <script>
          // 當 iframe 內容載入完成後執行
          const adsIframe = document.getElementById('ads-iframe');
          document.getElementById('ads-iframe').onload = function() {
            const iframeDoc = adsIframe.contentDocument || adsIframe.contentWindow.document;
            const script = iframeDoc.createElement('script');
            script.async = true;
            script.text = 'var parentWindow = window.parent;var parentDoc = parentWindow.document;var adRoot = parentDoc.createElement("div");adRoot.id = "ad-root";parentDoc.body.appendChild(adRoot);parentWindow.adSetting = ${JSON.stringify(payload)};var s = document.createElement("script");s.src = "/api/scripts/${jsModule}.js";s.async = true;const frameEl = window.frameElement;try { parentDoc.body.insertBefore(s, window.frameElement)} catch (e) {parentDoc.body.appendChild(s);}'
            iframeDoc.head.appendChild(script);
          };
        </\` + 'script>'
        doc.open();
        doc.write(content);
        doc.close();
      </script>
      `
      setIframeSrcDoc(category === '文中' ? inreadContent : htmlContent)
    }

    generateSrcDoc()
  }, [
    name,
    type,
    category,
    hasIntroAnimation,
    introAnimation,
    useSplitMp4,
    showIntro,
    correspondImgs,
    correspondVideos,
    showMedia,
    showFirstImage,
    pageFlipRedirectUrl,
    device,
    uploadedImages,
    srcs,
    likes,
    comments,
    shares,
    postText,
    titleText,
    boldTexts,
    contentTexts,
    btnTexts,
    pageFlipImageRedirectUrl,
    pageFlipVideoRedirectUrl,
  ])

  const [savingStatus, setsavingStatus] = useState('')
  const handleSave = async (cachedSrc) => {
    setsavingStatus('上傳檔案中...')
    const isBlobUrl = (value) =>
      typeof value === 'string' && value.startsWith('blob:')

    const blobUrlToFile = async (blobUrl, filename = 'upload.png') => {
      console.log(blobUrl)
      const res = await fetch(blobUrl)
      const blob = await res.blob()
      return new File([blob], filename, { type: blob.type })
    }

    const uploadedSrcs = await Promise.all(
      cachedSrc.map(async (item, index) => {
        console.log('uploading this')
        console.log(item)
        let cacheUrl = ''
        if (item.file instanceof File || isBlobUrl(item.file)) {
          if (item.cache) {
            console.log('makeing cache file')
            const blob = await cacheToZip(item.cache);
            // const blob = new Blob([JSON.stringify(item.cache)], { type: 'application/json' });
            console.log(blob)
            const formData = new FormData();
            formData.append('file', blob, 'frames.zip');
            const uploadedZip = await apiServices.data({
              path: 'creative/material',
              method: 'post',
              data: formData,
              contentType: 'multipart/form-data',
              params: { projectId }
            });
            console.log(uploadedZip)
            // const cacheToUpload = await blobUrlToFile(blob, `${uploadedImages[index].file.name}_cache`)
            // console.log(cacheToUpload)
            cacheUrl = `/api/file/${uploadedZip}`
          }
          const fileToUpload =
            item.file instanceof File
              ? item.file
              : await blobUrlToFile(item.file, uploadedImages[index].file.name)
          const url = await handleUpload(fileToUpload)
          return { ...item, file: url, cache: !!item.cache, cacheUrl }
        }
        return item
      })
    )

    const uploadedIntro =
      introAnimation instanceof File || isBlobUrl(introAnimation)
        ? await handleUpload(
            introAnimation instanceof File
              ? introAnimation
              : await blobUrlToFile(introAnimation, 'intro')
          )
        : introAnimation

    const uploadedImgs = await Promise.all(
      correspondImgs.map(async (item) => {
        if (item?.file instanceof File || isBlobUrl(item?.file)) {
          const fileToUpload =
            item.file instanceof File
              ? item.file
              : await blobUrlToFile(item.file, item.label)
          const url = await handleUpload(fileToUpload)
          return { ...item, file: url, preview: url }
        }
        return item
      })
    )

    const uploadedVids = await Promise.all(
      correspondVideos.map(async (item) => {
        if (item?.file instanceof File || isBlobUrl(item?.file)) {
          const fileToUpload =
            item.file instanceof File
              ? item.file
              : await blobUrlToFile(item.file, item.label)
          const url = await handleUpload(fileToUpload)
          return { ...item, file: url, preview: url }
        }
        return item
      })
    )

    setsavingStatus('上傳廣告中...')
    const finalPayload = {
      name,
      type,
      category,
      hasIntroAnimation,
      introAnimation: uploadedIntro,
      useSplitMp4,
      showIntro,
      correspondImgs: uploadedImgs,
      correspondVideos: uploadedVids,
      showMedia,
      showFirstImage,
      pageFlipRedirectUrl,
      device,
      uploadedImages,
      srcs: uploadedSrcs,
      likes,
      comments,
      shares,
      postText,
      titleText,
      boldTexts,
      contentTexts,
      btnTexts,
      pageFlipImageRedirectUrl,
      pageFlipVideoRedirectUrl,
    }

    console.log('📦 上傳後 payload:', finalPayload)
    handleUploadSettings(finalPayload)
    setsavingStatus('')

    handleClose()
  }

  const handleTransformAndSave = () => {
    setsavingStatus('分解開場動畫中...')
    const introSrc = srcs.find((item) => item.label === 'Intro video')
    if ((introSrc && introSrc.file) || (hasIntroAnimation && introAnimation)) {
      const tempIntro = document.createElement('video')
      Object.assign(tempIntro, {
        src: introSrc?.file || URL.createObjectURL(introAnimation),
        muted: true,
        playsInline: true,
      });
      Object.assign(tempIntro.style, { width: '100%', height: 'auto', objectFit: 'cover' });
      document.body.appendChild(tempIntro)
      transformer.transformVideo(tempIntro, (cache) => {
        console.log(cache)
        const cachedSrc = srcs.map((item) => item.label === 'Intro video' ? {
          ...item,
          cache,
        } : item)
        handleSave(cachedSrc)
      })
      tempIntro.remove()
    } else {
      handleSave(srcs)
    }
  }
  console.log(introAnimation)

  return (
    <Modal
      style={{ zIndex: '1501' }}
      show={show}
      size="xl"
      onHide={handleClose}
      className="py-2 px-4"
    >
      <Modal.Header className="h5" closeButton size="sm">
        建立創意版位
      </Modal.Header>
      <Modal.Body
        className="p-4 d-flex flex-column"
        style={{ height: '74vh', overflow: 'auto' }}
      >
        {loading || savingStatus ? (
          <div className="d-flex h-100 justify-content-center">
            <Spinner
              className="my-auto"
              animation="border"
              size="sm"
              style={{
                animation: 'spinner-border 1.5s linear infinite',
              }}
            />
            <h5 className="text-dai fs-4 my-auto ms-2">{savingStatus || '資料載入中...'}</h5>
          </div>
        ) : (
          <>
            <Row className="p-2 fw-bold">
              <Col xs={5} className="d-flex">
                <h5 className="mb-0 mb-auto">設定</h5>
                <Button
                  className="w-35 ms-auto"
                  variant="dai"
                  size="sm"
                  onClick={addUploadField}
                  disabled={
                    type === '行動置底展開' ||
                    type === '圖中圖' ||
                    type === '雙面旋轉' ||
                    type === '置底-雙面旋轉' ||
                    type === '左右PK' ||
                    type === '互動轉盤' ||
                    type === '拖曳互動' ||
                    type === '告示牌大橫幅廣告' ||
                    type === '告示牌影音橫幅廣告' ||
                    type === '文中影音廣告'
                  }
                >
                  <FontAwesomeIcon icon={faCirclePlus} /> 新增圖片欄位
                </Button>
              </Col>
              <Col xs={7} className="d-flex">
                <h5 className="mb-0 mb-auto">預覽</h5>
                {category === '置底' && (
                  <Button
                    size="sm"
                    variant="outline-dai"
                    className="my-auto ms-2 px-2"
                    style={{
                      fontSize: '11px',
                      paddingTop: '.1rem',
                      paddingBottom: '.1rem',
                    }}
                    onClick={() => {
                      setHasIntroAnimation(false)
                      setTimeout(() => {
                        setHasIntroAnimation(true)
                        setShowIntro(true)
                        setShowMedia(true)
                      }, 10)

                      setShowFirstImage(true)
                      setTimeout(() => {
                        setShowFirstImage(false)
                      }, 3000)

                      setIntroKey((prev) => prev + 1)
                      setIntroResetKey((prev) => prev + 1)

                      resetPreview()
                    }}
                  >
                    重置開場動畫
                  </Button>
                )}
              </Col>
            </Row>
            <Row
              style={{
                height: '74vh',
                minHeight: '74vh',
              }}
            >
              <Col xs={5} className="d-flex flex-column">
                <Row className="ps-2 my-2">
                  <Col className="d-flex" xs={1}>
                    <Form.Label className="my-auto text-nowrap">
                      名稱
                    </Form.Label>
                  </Col>
                  <Col xs={6}>
                    <Form.Control
                      className="ms-1"
                      value={name}
                      size="sm"
                      onChange={(e) => setName(e.target.value)}
                    />
                  </Col>
                </Row>
                <div className="sticky-top bg-white pb-2">
                  <Row className="p-2 pb-0">
                    <div style={{ width: '12%' }} className="d-flex pe-0">
                      <Form.Label className="my-auto">裝置</Form.Label>
                    </div>
                    <div style={{ width: '23%' }} className="px-0">
                      <Form.Select
                        size="sm"
                        value={device}
                        onChange={(e) => {
                          setDevice(e.target.value)
                          setCategory('')
                          setType('')
                        }}
                      >
                        <option value="行動裝置">行動裝置</option>
                        <option value="桌機">桌機</option>
                      </Form.Select>
                    </div>
                    <div style={{ width: '12%' }} className="d-flex pe-0">
                      <Form.Label className="my-auto">類別</Form.Label>
                    </div>
                    <div style={{ width: '17%' }} className="px-0">
                      <Form.Select
                        size="sm"
                        value={category}
                        onChange={handleCategoryChange}
                      >
                        <option value="">未選擇</option>
                        <option value="蓋板">蓋板</option>
                        <option value="文中">文中</option>
                        <option value="置底">置底</option>
                      </Form.Select>
                    </div>
                    <div style={{ width: '12%' }} className="d-flex pe-0">
                      <Form.Label className="m-auto">版位</Form.Label>
                    </div>
                    <div style={{ width: '23%' }} className="px-0">
                      <Form.Select
                        size="sm"
                        value={type}
                        onChange={handleTypeChange}
                        disabled={!category}
                      >
                        <option value="">未選擇</option>
                        {(device === '行動裝置'
                          ? categories
                          : desktopCategories)[category]?.map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </Form.Select>
                    </div>
                  </Row>
                </div>

                {(hasIntroAnimation || srcs.find((item) => item.label === 'Intro video')) && <Row className="p-2 border-bottom">
                  <Col className="d-flex">
                    <Form.Check
                      type="switch"
                      label="啟用透明背景開場動畫(分割式mp4)"
                      checked={useSplitMp4}
                      onChange={() => {
                        setUseSplitMp4((prev) => !prev)
                      }}
                      className="align-content-center"
                    />
                  </Col>
                </Row>}

                {device === '行動裝置' &&
                  category === '置底' &&
                  type !== '開場+320H靜態廣告' &&
                  type !== '開場+320H動態廣告' &&
                  type !== '開場+320H翻玩廣告' &&
                  type !== '開場+320H翻玩影音廣告' && (
                    <Row className="p-2 border-bottom">
                      <Col xs={5} className="d-flex">
                        <Form.Check
                          type="switch"
                          label="啟用開場動畫"
                          checked={hasIntroAnimation}
                          onChange={() => {
                            setHasIntroAnimation((prev) => !prev)
                            if (!hasIntroAnimation) {
                              setShowIntro(true)
                            }
                          }}
                          className="align-content-center"
                        />
                      </Col>
                      {hasIntroAnimation && (
                        <Col xs={7} className="d-flex align-content-center">
                          <NamedInput
                            setting={{
                              file: introAnimation,
                              size: 'sm',
                              type: 'file',
                              accept: 'image/*,video/*',
                              onChange: (e) =>
                                setIntroAnimation(e.target.files[0]),
                            }}
                          />
                        </Col>
                      )}
                    </Row>
                  )}
                <div
                  style={{
                    maxHeight: '15rem',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                  }}
                >
                  {srcs.map((src, index) => (
                    <Row key={index} className="p-2 border-bottom">
                      <Col className="d-flex" xs={5}>
                        <Form.Label className="my-auto">{src.label}</Form.Label>
                      </Col>
                      <Col xs={7}>
                        <NamedInput
                          setting={{
                            file: uploadedImages[index],
                            size: 'sm',
                            type: 'file',
                            accept: 'image/*,video/*',
                            onChange: (e) => handleFileChange(e, index),
                          }}
                        />
                        {/* <Form.Control
                      size="sm"
                      type="file"
                      onChange={(e) => handleFileChange(e, index)}
                    /> */}
                      </Col>
                    </Row>
                  ))}
                </div>

                <div
                  className="bg-white pt-3"
                  style={{
                    maxHeight: '10rem',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                  }}
                >
                  {type === '社群貼文' && (
                    <>
                      <Row className="p-2 pb-0">
                        <Col xs={12}>
                          <Form.Control
                            size="sm"
                            type="text"
                            placeholder="輸入社群貼文標題..."
                            value={titleText}
                            onChange={(e) => setTitleText(e.target.value)}
                          />
                        </Col>
                      </Row>
                      <Row className="p-2 pb-0">
                        <Col xs={4}>
                          <Form.Control
                            size="sm"
                            type="text"
                            placeholder="讚數"
                            value={likes}
                            onChange={(e) => setLikes(e.target.value)}
                          />
                        </Col>
                        <Col xs={4} className="px-0">
                          <Form.Control
                            size="sm"
                            type="text"
                            placeholder="留言數"
                            value={comments}
                            onChange={(e) => setComments(e.target.value)}
                          />
                        </Col>
                        <Col xs={4}>
                          <Form.Control
                            size="sm"
                            type="text"
                            placeholder="分享數"
                            value={shares}
                            onChange={(e) => setShares(e.target.value)}
                          />
                        </Col>
                      </Row>
                      <Row className="p-2 border-bottom">
                        <Col xs={12}>
                          <Form.Control
                            size="sm"
                            as="textarea"
                            rows={3}
                            placeholder="輸入社群貼文內容..."
                            value={postText}
                            onChange={(e) => setPostText(e.target.value)}
                          />
                        </Col>
                      </Row>
                    </>
                  )}

                  {type === '旋轉木馬' && srcs.length > 0 && (
                    <>
                      {srcs.map((img, idx) => (
                        <div key={idx} className="mb-2">
                          <Row className="p-2 pb-0">
                            <Col xs={12}>
                              <Form.Control
                                size="sm"
                                type="text"
                                placeholder={`輸入Pic ${idx + 1} 標題...`}
                                value={boldTexts[idx] || ''}
                                onChange={(e) => {
                                  const newBoldTexts = [...boldTexts]
                                  newBoldTexts[idx] = e.target.value
                                  setBoldTexts(newBoldTexts)
                                }}
                              />
                            </Col>
                          </Row>
                          <Row className="p-2 pb-0">
                            <Col xs={7}>
                              <Form.Control
                                size="sm"
                                type="text"
                                placeholder={`輸入Pic ${idx + 1} 內文...`}
                                value={contentTexts[idx] || ''}
                                onChange={(e) => {
                                  const newContentTexts = [...contentTexts]
                                  newContentTexts[idx] = e.target.value
                                  setContentTexts(newContentTexts)
                                }}
                              />
                            </Col>
                            <Col xs={5} className="">
                              <Form.Control
                                size="sm"
                                type="text"
                                placeholder="按鈕文字"
                                value={btnTexts[idx] || ''}
                                onChange={(e) => {
                                  const newBtnTexts = [...btnTexts]
                                  newBtnTexts[idx] = e.target.value
                                  setBtnTexts(newBtnTexts)
                                }}
                              />
                            </Col>
                          </Row>
                        </div>
                      ))}
                    </>
                  )}

                  {type === '翻玩展開' && (
                    <>
                      {srcs.map((src, index) => (
                        <div key={index} className="">
                          <Row className="p-2 border-bottom">
                            <Col xs={5} className="d-flex">
                              <Form.Label className="align-content-center">
                                Pic {index + 1} 對應圖片
                              </Form.Label>
                            </Col>
                            <Col xs={7}>
                              <NamedInput
                                setting={{
                                  file: correspondImgs[index],
                                  size: 'sm',
                                  type: 'file',
                                  accept: 'img/*',
                                  onChange: (e) =>
                                    handleCorrespondImgChange(e, index),
                                }}
                              />
                              {/* <Form.Control
                            size="sm"
                            type="file"
                            onChange={(e) =>
                              handleCorrespondImgChange(e, index)
                            }
                          /> */}
                            </Col>
                          </Row>
                        </div>
                      ))}
                    </>
                  )}

                  {['開場+320H翻玩廣告', '開場+320H翻玩影音廣告'].includes(
                    type
                  ) &&
                    srcs
                      .filter((src) => src.label?.startsWith('Pic'))
                      .map((src, index) => (
                        <div key={index}>
                          <Row className="p-2 border-bottom">
                            <Col xs={5} className="d-flex">
                              <Form.Label className="align-content-center">
                                {src.label} 對應圖片
                              </Form.Label>
                            </Col>
                            <Col xs={7}>
                              <NamedInput
                                setting={{
                                  file: correspondImgs[index],
                                  size: 'sm',
                                  type: 'file',
                                  accept: 'img/*',
                                  onChange: (e) =>
                                    handleCorrespondImgChange(e, index),
                                }}
                              />
                              {/* <Form.Control
                            size="sm"
                            type="file"
                            onChange={(e) =>
                              handleCorrespondImgChange(e, index)
                            }
                          /> */}
                            </Col>
                          </Row>
                        </div>
                      ))}

                {(type === '飛梭膠卷影音廣告' ||
                  type === '翻玩展開') && (
                    <>
                      {srcs.map((src, index) => (
                        <div key={index} className="">
                          <Row className="p-2 border-bottom">
                            <Col xs={5} className="d-flex">
                              <Form.Label className="align-content-center">
                                Pic {index + 1} 對應影片
                              </Form.Label>
                            </Col>
                            <Col xs={7}>
                              <NamedInput
                                setting={{
                                  file: correspondVideos[index],
                                  size: 'sm',
                                  type: 'file',
                                  accept: 'video/*',
                                  onChange: (e) =>
                                    handleCorrespondVideoChange(e, index),
                                }}
                              />
                            </Col>
                          </Row>
                        </div>
                      ))}
                    </>
                  )}

                  {/* 單網址 */}
                  {(type === '預設輪播' ||
                    type === '蓋板輪播Sticky' ||
                    type === '置底迴廊' ||
                    type === '手翻型錄廣告' ||
                    type === '告示牌大橫幅廣告' ||
                    type === '告示牌影音橫幅廣告' ||
                    type === '文中影音廣告' ||
                    type === '文中輪播' ||
                    type === '置底輪播' ||
                    type === '全屏畫布' ||
                    type === '滑動蓋板' ||
                    type === '滑動蓋板（多圖）' ||
                    type === '開場+320H靜態廣告' ||
                    type === '開場+320H翻玩廣告' ||
                    type === '手翻型錄Banner廣告' ||
                    type === '魔法卡片' ||
                    type === '飛梭膠卷影音廣告' ||
                    type === '便利貼' ||
                    type === '便利貼（輪播）' ||
                    type === '切入式廣告' ||
                    type === '翻玩展開' ||
                    type === '跑馬燈' ||
                    type === '置底-雙面旋轉' ||
                    type === '雙面旋轉' ||
                    type === '展示影音' ||
                    type === '旋轉木馬' ||
                    type === '行動置底展開') && (
                    <Row className="p-2 border-bottom">
                      <Col xs={5} className="d-flex">
                        <Form.Label className="align-content-center">
                          設定彈出網址
                        </Form.Label>
                      </Col>
                      <Col xs={7}>
                        <Form.Control
                          size="sm"
                          type="text"
                          placeholder="https://example.com"
                          value={pageFlipRedirectUrl}
                          onChange={(e) => setPageFlipRedirectUrl(e.target.value)}
                        />
                      </Col>
                    </Row>
                  )}

                  {/* 雙網址 */}
                  {(type === '開場+320H動態廣告' ||
                    type === '視覺雙響-文中翻頁蓋板+快閃動畫' ||
                    type === '開場+320H翻玩影音廣告' ||
                    type === '翻書影音廣告' ||
                    type === '拖曳互動' ||
                    type === '切入式廣告(影片)' ||
                    type === '包框影音') && (
                    <>
                      <Row className="p-2 border-bottom">
                        <Col xs={5} className="d-flex">
                          <Form.Label className="align-content-center">
                            設定圖片彈出網址
                          </Form.Label>
                        </Col>
                        <Col xs={7}>
                          <Form.Control
                            size="sm"
                            type="text"
                            placeholder="https://example.com"
                            value={pageFlipImageRedirectUrl}
                            onChange={(e) => {
                              setPageFlipImageRedirectUrl(e.target.value)
                              console.log('Image URL changed:', e.target.value)
                            }}
                          />
                        </Col>
                      </Row>
                      <Row className="p-2 border-bottom">
                        <Col xs={5} className="d-flex">
                          <Form.Label className="align-content-center">
                            設定影片彈出網址
                          </Form.Label>
                        </Col>
                        <Col xs={7}>
                          <Form.Control
                            size="sm"
                            type="text"
                            placeholder="https://example.com"
                            value={pageFlipVideoRedirectUrl}
                            onChange={(e) =>
                              setPageFlipVideoRedirectUrl(e.target.value)
                            }
                          />
                        </Col>
                      </Row>
                    </>
                  )}

                  {/* 三網址 */}
                  {type === '置底互動轉盤' && (
                    <>
                      <Row className="p-2 border-bottom">
                        <Col xs={5} className="d-flex">
                          <Form.Label className="align-content-center">
                            設定第一彈出網址
                          </Form.Label>
                        </Col>
                        <Col xs={7}>
                          <Form.Control
                            size="sm"
                            type="text"
                            placeholder="https://example.com/page1"
                            value={threeRedirectUrl1}
                            onChange={(e) => setThreeRedirectUrl1(e.target.value)}
                          />
                        </Col>
                      </Row>
                      <Row className="p-2 border-bottom">
                        <Col xs={5} className="d-flex">
                          <Form.Label className="align-content-center">
                            設定第二彈出網址
                          </Form.Label>
                        </Col>
                        <Col xs={7}>
                          <Form.Control
                            size="sm"
                            type="text"
                            placeholder="https://example.com/page2"
                            value={threeRedirectUrl2}
                            onChange={(e) => setThreeRedirectUrl2(e.target.value)}
                          />
                        </Col>
                      </Row>
                      <Row className="p-2 border-bottom">
                        <Col xs={5} className="d-flex">
                          <Form.Label className="align-content-center">
                            設定第三彈出網址
                          </Form.Label>
                        </Col>
                        <Col xs={7}>
                          <Form.Control
                            size="sm"
                            type="text"
                            placeholder="https://example.com/page3"
                            value={threeRedirectUrl3}
                            onChange={(e) => setThreeRedirectUrl3(e.target.value)}
                          />
                        </Col>
                      </Row>
                    </>
                  )}
                </div>
              </Col>

              <Col className='d-flex overflow-hidden' ref={frameContainerRef} xs={7}>
                {jsModuleTypes[type] ? (
                    <iframe className='mx-auto' width="100%" height="100%" title="adpreview" srcDoc={iframeSrcDoc} />
                  ) : (
                <div
                  className={`mx-auto px-1 pt-2 ${
                    device === '行動裝置' ? 'w-40' : 'w-70'
                  }`}
                >
                    {renderPreview()}
                </div>)}
              </Col>
            </Row>
            <Row>
              <TrackerSetting
                setting={{
                  creative_id,
                }}
              />
            </Row>
          </>
        )}
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button
          className="ms-auto"
          variant="secondary"
          onClick={handleClose}
          size="sm"
        >
          取 消
        </Button>
        <Button
          className="me-auto"
          variant="outline-dai"
          onClick={handleTransformAndSave}
          size="sm"
        >
          儲 存
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

CreativeModal.propTypes = {
  setting: PropTypes.shape().isRequired,
}

TrackerSetting.propTypes = {
  setting: PropTypes.shape().isRequired,
}

NamedInput.propTypes = {
  setting: PropTypes.shape().isRequired,
}

export default CreativeModal
